import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';

import {
  throwError,
  getEntityType,
} from './helpers';
import {
  actionTypes,
  requestFetchClientEntity,
} from '../actions';
import api from '../api';

const resourceTypes = [
  // 'workoutExercises',
  'personalWarmups',
  'personalWorkouts',
  'personalCooldowns',
  'personalExercises',
  'personalPrograms',
];

export default function* initialClientResources() {
  function* fetchPersonalEntity({
    requestKey,
    resourceType,
  }) {
    const actions = createActionCreators('read', {
      resourceType,
      requestKey: requestKey || 'fetchPersonalEntity',
    });

    try {
      yield eff.put(actions.pending());

      const resources = yield eff.call(
        api.getPersonalEntity,
        {
          type: getEntityType(resourceType),
        },
      );

      yield eff.put(actions.succeeded({
        list: 'library',
        resources,
      }));
      return resources;
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
    return [];
  }

  function* fetchResources({ callbacks, requestKey } = {}) {
    try {
      const all = yield eff.all(
        resourceTypes.map(
          resourceType => eff.call(
            fetchPersonalEntity,
            {
              requestKey,
              resourceType,
            },
          ),
        ),
      );

      callbacks?.onSuccess?.(all);
    } catch (e) {
      callbacks?.onError?.(e);

      yield eff.call(throwError, e);
    }
  }

  function* getPros() {
    const actions = createActionCreators('read', {
      resourceType: 'pros',
      requestKey: 'fetchPros',
    });

    try {
      yield eff.put(actions.pending());

      const resources = yield eff.call(
        api.getPersonalEntity,
        {
          type: 'pros',
        },
      );

      // Fetch product and plas
      const pro = resources.find(r => r.live);
      if (pro?.id) {
        yield eff.put(
          requestFetchClientEntity({
            clientId: pro.id,
            resourceType: 'products',
          }),
        );
        yield eff.put(
          requestFetchClientEntity({
            clientId: pro.id,
            resourceType: 'productPlans',
          }),
        );
      }

      yield eff.put(actions.succeeded({
        resources,
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, e);
    }
  }

  yield fetchResources();
  yield getPros();

  yield eff.put({
    type: actionTypes.REQUEST_CURRENT_CUSTOMER,
  });
  yield eff.put({
    type: actionTypes.REQUEST_GET_PAYMENT_METHODS,
  });

  yield eff.takeEvery(actionTypes.REQUEST_FETCH_RESOURCES, fetchResources);
}
